<template>
  <div
    v-auto-focus
    role="region"
    tabindex="0"
    :aria-label="computedAriaLabel"
    class="focus-invisible"
  >
    <slot></slot>
  </div>
</template>

<script>
import i18n from '../../i18n';
export default {
  props: {
    state: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedAriaLabel() {
      switch (this.state.step) {
        case 'CUSTOMFIELDS':
          return i18n.gettext('Custom fields');
        case 'CONTACT':
          return i18n.gettext('Check out');
        case 'DEPOSIT':
          return i18n.gettext('Deposit Section');
        case 'VERIFY_SECURITY_CODE':
          return i18n.gettext('Security-Pin Section');
        case 'CONFIRMATION':
          return i18n.gettext('Booking creation confirmation.');
        case 'EXTERNAL':
          return i18n.gettext('Booking confirmation');
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss"></style>
